export function updateAppointment(appointment) {
	return {
		type: 'UPDATE_APPOINTMENT',
		payload: {
			appointment: appointment
		}
	}
}

export function updateDate(date) {
	return {
		type: 'UPDATE_DATE',
		payload: {
			date: date
		}
	}
}

export function updateActiveDay(index) {
	console.log(index)
	return {
		type: 'UPDATE_ACTIVEDAY',
		payload: {
			activeDay: index
		}
	}
}

export function updateTimeslot(timeslot) {
	return {
		type: 'UPDATE_TIMESLOT',
		payload: {
			timeslot: timeslot,
		}
	}
}

export function updateActiveTimeslot(activeTimeslot) {
	return {
		type: 'UPDATE_ACTIVETIMESLOT',
		payload: {
			activeTimeslot: activeTimeslot,
		}
	}
}

export function updatePersonalInformation(personalInformation) {
	return {
		type: 'UPDATE_PERSONAL_INFORMATION',
		payload: {
			firstname: personalInformation.firstname,
			lastname: personalInformation.lastname,
			email: personalInformation.email,
			phone: personalInformation.phone,
			country: personalInformation.country,
			company: personalInformation.company,
			industry: personalInformation.industry,
			companysize: personalInformation.companysize,
			description: personalInformation.description,
			newsletter: personalInformation.newsletter,
		}
	}
}


